const DB_NAME = 'ventanerosFormDB';
const DB_VERSION = 1;
const STORE_NAME = 'formData';

export class FormStorage {
  private db: IDBDatabase | null = null;

  async init(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = (event) => {
        console.error('Error opening database:', event);
        reject(request.error);
      };

      request.onsuccess = () => {
        this.db = request.result;
        resolve();
      };

      request.onupgradeneeded = (event) => {
        console.log('Updating database...');
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id' });
          console.log('Object store created:', STORE_NAME);
        }
      };
    });
  }

  async saveFormData(data: any): Promise<void> {
    if (!this.db) {
      await this.init();
    }

    return new Promise((resolve, reject) => {
      const transaction = this.db!.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put({ id: 'currentForm', ...data });

      request.onsuccess = () => {
        resolve();
      };
      request.onerror = (event) => {
        console.error('Error saving data:', event);
        reject(request.error);
      };
    });
  }

  async getFormData(): Promise<any> {
    if (!this.db) {
      console.log('Database not initialized, initializing...');
      await this.init();
    }

    return new Promise((resolve, reject) => {
      const transaction = this.db!.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get('currentForm');

      request.onsuccess = () => {
        console.log('Data retrieved:', request.result);
        resolve(request.result);
      };
      request.onerror = (event) => {
        console.error('Error retrieving data:', event);
        reject(request.error);
      };
    });
  }

  async clearFormData(): Promise<void> {
    console.log('Clearing data...');
    if (!this.db) {
      console.log('Database not initialized, initializing...');
      await this.init();
    }

    return new Promise((resolve, reject) => {
      const transaction = this.db!.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete('currentForm');

      request.onsuccess = () => {
        console.log('Data cleared successfully');
        resolve();
      };
      request.onerror = (event) => {
        console.error('Error clearing data:', event);
        reject(request.error);
      };
    });
  }
}

export const formStorage = new FormStorage();